<template>
    <LayoutSub className="shop">
        <div class="tab_menu">
            <button @click="changeContent('easypos')" :class="activeContent === 'easypos' ? 'selected' : ''">이지포스 모바일</button>
            <button @click="changeContent('asp')" :class="activeContent === 'asp' ? 'selected' : ''">스마트 ASP</button>
        </div>
        <SubSection class="content p-0" v-if="activeContent === 'easypos'">
            <SubpageTitleContainer
                class="pt-0 pb-80"
                :title="`이지포스 모바일 (EasyPos Mobile)`"
                :subText="`이지포스 매장관리를 모바일로 손쉽게 할 수 있어요. 가맹점 매출분석, 수발주, 푸시, 실시간주문현황 등 기능이 탑재된 어플리케이션입니다.<br>모바일 프로는 한층 더 업그레이드 된 서비스로 생체로그인, 홈화면에서 바로 매출데이터 확인 등을 확인할 수 있습니다.`"
            >
            </SubpageTitleContainer>
            <StickyContainer
                title="이지포스 모바일(프로)"
                :appButtons="[
                    { link: 'https://play.google.com/store/apps/details?id=kr.kicc.easypospro&pcampaignid=web_share', img: require('@/assets/google_play_down.png'), alt: 'google' },
                    { link: 'https://apps.apple.com/kr/app/easypos-mobile-pro/id1059599823', img: require('@/assets/app_store_down.png'), alt: 'app' },
                ]"
                :leftItems="shopLeftItems"
                :rightItems="shopRightItems"
                :isSpecialPage="true"
                secondTitle="이지포스 모바일(무료)"
                :freeAppButtons="[
                    { link: 'https://play.google.com/store/apps/details?id=com.kicc.easypos.mobile&pcampaignid=web_share', img: require('@/assets/google_play_down.png'), alt: 'google' },
                    { link: 'https://apps.apple.com/kr/app/easypos-%EB%AA%A8%EB%B0%94%EC%9D%BC/id445323924', img: require('@/assets/app_store_down.png'), alt: 'app' },
                ]"
            >
            </StickyContainer>
        </SubSection>
        <SubSection class="content p-0" v-else>
            <SubpageTitleContainer
                class="pt-0 pb-80"
                :title="`스마트ASP (SmartASP)`"
                :subText="`다양한 어플리케이션과 데이터를 똑똑하게 관리하기 위한 다양한 백 오피스 기능을 함께 제공합니다.`"
            ></SubpageTitleContainer>
            <div class="table-2grid">
                <TableRow_2grid
                    :title="`상품정보 추가 및 수정`"
                    :content="`판매하고자 하는 상품의 사진/가격부터 선택해야 하는 옵션까지, 원하는대로 상품정보를 세팅할 수 있습니다.`"
                    :src="`sub_icon01.png`"
                />
                <TableRow_2grid
                    :title="`쿠폰, 프로모션 설정`"
                    :content="`자체쿠폰부터 외부사 쿠폰까지 생성하고, 원하는 기간/상품/혜택 조건으로 프로모션을 만들 수 있습니다.`"
                    :src="`sub_icon02.png`"
                />
                <TableRow_2grid
                    :title="`장비, 매장관리`"
                    :content="`주방장비(프린터,KDS)에 메뉴설정 부터, 사원등록 및 관리, 직책별 권한 제어 등을 할 수 있습니다.`"
                    :src="`sub_icon03.png`"
                />
                <TableRow_2grid
                    :title="`매출분석 및 승인관리`"
                    :content="`일별/주별/월별 그리고 다양한 결제수단별 매출을 분석할 수 있습니다. 신용카드 승인은 카드사별로도 관리가 가능합니다.`"
                    :src="`sub_icon04.png`"
                />
                <TableRow_2grid
                    :title="`고객 포인트 관리`"
                    :content="`매장에서 원하는대로 고객등급 정책을 만들 수 있습니다. 신규 고객 등록, 고객들 포인트 관리, 정해진 주기별 관리 등이 가능합니다.`"
                    :src="`sub_icon05.png`"
                />
                <TableRow_2grid
                    :title="`재고 관리`"
                    :content="`본사와 매장 간 재고를 실시간으로 관리할 수 있습니다. 복잡한 재고관리를 자동화할 수 있어요.`"
                    :src="`sub_icon06.png`"
                />
            </div>
        </SubSection>
    </LayoutSub>
</template>

<script>
import StickyContainer from '@/components/StickyContainer.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        StickyContainer,
        SubpageTitleContainer,
        TableRow_2grid,
    },
    data() {
        return {
            activeContent: 'easypos',
            shopLeftItems: [
                { text: '홈화면', active: true },
                { text: '매출조회', active: false },
                { text: '전체보기', active: false },
                { text: '실시간 현황 화면', active: false },
                { text: '주문재고(1)', active: false },
                { text: '주문재고(2)', active: false },
                { text: '그 외 기능(1)', active: false },
                { text: '그 외 기능(2)', active: false },
                { text: '', active: false },
            ],
            shopRightItems: [
                {
                    img: require('@/assets/easy_img_01.png'),
                    title: '홈화면',
                    description: '홈 화면에서 매출과 공지사항, 푸시알림과 같은 주요 정보를 한눈에 볼 수 있도록 수정',
                    shoplist: [
                        '가장 최신 공지를 상단에 배치',
                        '실시간과 전주, 전일 매출 홈 화면 배치',
                        '당일 결제수단별 매출 원형차트로 시각화 (각 수단별 차지 비율 비교 편의제공)',
                        '1주일간 매출 막대차트로 시각화 (일간 매출 비교)',
                        '당일 상품순위 원형차트로 시각화 (상품별 매출 차지 비율 제공)',
                    ],
                },
                {
                    img: require('@/assets/easy_img_02.png'),
                    title: '매출조회',
                    shoplist: [
                        '캘린더 형태로 항목별 매출 조회 가능 (총매출/순매출/반품액/할인액/고객수/영수건수)',
                        '금액별 단위변경 (원/천원/백만원)',
                        '선택날짜와 선택 불가날짜 UI 상이',
                        '월별캘린더 일별캘린더와 동일',
                    ],
                },
                {
                    img: require('@/assets/easy_img_03.png'),
                    title: '전체보기',
                    shoplist: [
                        '전체보기 화면 내 전 메뉴 표시',
                        '특정 메뉴 롱클릭시 즐겨찾기 등록 가능(등록시 최상단 메뉴로 배치)',
                        '즐겨찾기 등록 메뉴는 별 표시 <span>※ 취소는 해당 메뉴 다시 롱클릭</span>',
                    ],
                },
                {
                    img: require('@/assets/easy_img_04.png'),
                    title: '실시간 현황 화면',
                    shoplist: [
                        '가맹점 매출현황을 실시간으로 확인 가능',
                        '가맹점 내 층/테이블별로 주문현황 확인 가능(화면 상 1층/2층/테라스가 층별 정보, 4*5가 1층 내 테이블 정보)',
                        '두번째 탭인 실시간 현황은 설정 > 메뉴설정에서 실시간/주문재고/기타조회 중 선호하는 메뉴로 선택하여 사용 가능',
                    ],
                },
                {
                    img: require('@/assets/easy_img_05.png'),
                    title: '주문재고(1)',
                    shoplist: [
                        '상품 조회 : 상품명을 검색하여 조회 <span>이름에 검색어가 포함된 상품 조회</span>',
                        '조회 이후, 주문 등록 : 해당 버튼을 통해 발주 수량 조절',
                        '장바구니를 통해 주문 확정 가능 <span>*수정 및 삭제 가능</span>',
                        '주문현황을 조회 <span>*수정 및 삭제 불가</span>',
                    ],
                },
                {
                    img: require('@/assets/easy_img_06.png'),
                    title: '주문재고(2)',
                    shoplist: [
                        '상품 조회 : 바코드로 검색하여 조회 (바코드 스캔 가능)',
                        '상품 이름 검색 기능 <span>이름에 검색어가 포함된 상품 조회</span>',
                        '상품 등록 및 수정(검색이 선행되어야 함) 수정 불가 항목 제외, 상품정보 수정 가능<span>*재조회시 초기화 이후 진행</span>',
                    ],
                },
                {
                    img: require('@/assets/easy_img_07.png'),
                    title: '그 외 기능(1)',
                    shoplist: [
                        '상품 조회 : 바코드로 검색하여 조회 (바코드 스캔 기능)',
                        '단품실사등록 : 상품의 수량 입력 후, 하단 리스트 통해 저장 및 삭제',
                        '단품실사확정 : 단품실사 등록한 상품 확정 및 삭제',
                    ],
                },
                {
                    img: require('@/assets/easy_img_08.png'),
                    title: '그 외 기능(2)',
                    shoplist: [
                        '상품 조회 : 바코드로 검색하여 조회 (바코드 스캔 기능)',
                        '무발주 입고 등록 : 상품의 수량 입력 후, 하단 리스트 통해 저장 및 삭제',
                        '무발주 입고 관리 : 무발주 입고 등록한 내역에 대해서 확정 및 취소 가능',
                    ],
                },
                {
                    img: require('@/assets/easy_img_09.png'),
                    sectionTitle: '이지포스 모바일(무료)',
                    title: '주요 특징',
                    cards: [
                        {
                            img: require('@/assets/ic_management_01.png'),
                            title: '당일 정산내역 확인 가능',
                        },
                        {
                            img: require('@/assets/ic_management_02.png'),
                            title: '당월/일자별/월별 매출 확인가능',
                        },
                        {
                            img: require('@/assets/ic_management_03.png'),
                            title: '결제수단별/카드사별 매출 확인가능',
                        },
                        {
                            img: require('@/assets/ic_management_04.png'),
                            title: '본부 경우 매장별 매출 확인가능',
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        changeContent(content) {
            this.activeContent = content;
        },
    },
};
</script>

<style lang="scss">
.shop .sticky_container .left_area .list_area ul li:last-child {
    margin-top: 90px;
}

.section_title {
    display: none;

    & + .app_btn {
        display: none;
        @media screen and (max-width: 768px) {
            display: block;
        }
    }
    @media screen and (max-width: 768px) {
        display: block;
    }
}

</style>

<style scoped>
.subpage-title-wrapper {
    max-width: 100% !important;
}

@media screen and (max-width: 768px){
    .subpage-title-wrapper {
        max-width: 90% !important;
    }
}

.tab_menu {
    max-width: 1540px;
    @media screen and (max-width: 1024px){
        max-width: 90%;
    }
}
</style>
